export default __webpack_public_path__ + "static/media/logo2.d9364234.png";